import React from "react";
import { makeStyles } from "@material-ui/core";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import { KeyboardDatePicker, KeyboardDatePickerProps } from "@material-ui/pickers/DatePicker";
import DateFnsUtils from "@date-io/date-fns";
import { format, parseISO, isValid } from "date-fns";

const useStyles = makeStyles({
  root: {
    minWidth: "100%",
    "& > label": {
      zIndex: 10,
    },
  },
  input: {
    padding: "26px 32px 8px 13px",
  },
});

interface CustomDatePickerProps extends Omit<KeyboardDatePickerProps, "onChange" | "value"> {
  onChange: (date: string | null) => void;
  value: string | null;
  readonly?: boolean;
}

const CustomDatePickerTimeZoneSave = (props: CustomDatePickerProps) => {
  const classes = useStyles(props);
  const { id, label, disabled, disablePast, helperText, minDate, onChange, readOnly = false, value, ...rest } = props;

  const dateValue = value ? parseISO(value) : null;

  const handleDateChange = (date: Date | null) => {
    if (!date || !isValid(date)) {
      onChange(null);
    } else {
      onChange(format(date, "yyyy-MM-dd"));
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={classes.root}
        disabled={disabled}
        disablePast={disablePast}
        minDate={minDate}
        margin="normal"
        helperText={helperText}
        id={id}
        inputProps={{
          className: classes.input,
          readOnly,
        }}
        label={label}
        format="yyyy/MM/dd"
        value={dateValue}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
};

export default CustomDatePickerTimeZoneSave;
